var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5846 9.17443C22.8735 9.11649 28.8089 14.9268 28.8419 22.1517C28.8748 29.3766 22.9923 35.2803 15.7034 35.3383C8.41459 35.396 2.47908 29.5859 2.44613 22.361C2.41352 15.136 8.29567 9.23237 15.5846 9.17443ZM15.6206 17.0926C12.7433 17.1154 10.4215 19.4459 10.4344 22.2978C10.4472 25.1498 12.7902 27.4431 15.6675 27.4204C18.5448 27.3977 20.8666 25.0672 20.8537 22.2152C20.8408 19.3632 18.4978 17.0696 15.6206 17.0926Z",
    fill: "url(#paint0_linear_3599_5722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1079 20.4557C9.97112 20.8816 9.88648 21.328 9.86055 21.787C9.8575 21.8243 9.85493 21.8655 9.8533 21.9155C9.84839 22.0643 9.85135 22.2109 9.8591 22.3558C9.85951 22.3624 9.85943 22.3693 9.85984 22.3759C9.86813 22.523 9.88318 22.6675 9.90383 22.8098C9.90374 22.8104 9.9036 22.8106 9.90365 22.8109L2.31465 21.9222C2.46445 19.3064 3.3741 16.8515 4.81561 14.7942C4.81603 14.7936 4.81644 14.793 4.81686 14.7923C5.68182 13.5583 6.738 12.4672 7.93647 11.57C9.16315 12.687 10.6158 15.7229 10.1079 20.4557Z",
    fill: "url(#paint1_linear_3599_5722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.5826 9.1813C22.8723 9.12356 28.8085 14.9344 28.8415 22.1602C28.8482 23.6224 28.6138 25.029 28.1726 26.3456C28.1727 26.3432 28.1726 26.341 28.1726 26.341C28.1726 26.341 21.8033 30.2363 13.874 27.1291C14.4328 27.3291 15.0379 27.4344 15.6653 27.4294C18.5414 27.4067 20.8651 25.0745 20.8521 22.2236C20.8521 22.2236 21.2846 11.3926 14.492 9.2359C14.8531 9.20082 15.2166 9.1842 15.5826 9.1813Z",
    fill: "url(#paint2_linear_3599_5722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.7115 2.89881C10.764 5.61428 10.4096 20.4961 10.3814 21.8899C10.3756 22.1449 10.3646 22.2871 10.3646 22.2871C10.3747 24.5095 11.8007 26.3969 13.7934 27.1065C13.7979 27.1088 13.8026 27.1109 13.8074 27.111C21.738 30.2187 28.1083 26.3228 28.1083 26.3228C28.1083 26.3228 28.1082 26.3252 28.1083 26.3274C26.3716 31.5182 21.4507 35.2858 15.6351 35.3318C8.34431 35.3895 2.40716 29.5777 2.3742 22.3506L2.37383 22.2863L2.34845 22.2865L2.3514 1.16886C2.3514 1.16886 6.04173 -0.633364 8.7115 2.89881Z",
    fill: "url(#paint3_linear_3599_5722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.6,
    d: "M15.7102 35.3355C8.41787 35.3933 2.4795 29.58 2.44653 22.3512L2.44615 22.2868L2.42077 22.287L2.40321 12.7892C2.40321 12.7892 2.42592 12.7613 2.46725 12.7158L2.4842 21.867L2.50958 21.8668L2.50995 21.9312C2.54271 29.1599 8.48129 34.9733 15.7736 34.9155C21.4108 34.8709 26.2074 31.3302 28.0793 26.3856C28.1471 26.3476 28.186 26.3241 28.186 26.3241C28.186 26.3241 28.1861 26.3263 28.186 26.3287C26.4491 31.5211 21.5272 35.2894 15.7102 35.3355Z",
    fill: "url(#paint4_linear_3599_5722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.1829 26.3459C28.183 26.3435 28.1829 26.3413 28.1829 26.3413C28.1829 26.3413 21.8139 30.2364 13.8848 27.1294C13.8848 27.1294 21.9306 30.0129 28.6842 24.3125C28.5714 25.0098 28.4028 25.689 28.1829 26.3459Z",
    fill: "url(#paint5_linear_3599_5722)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3599_5722",
    x1: 15.7041,
    y1: 35.3383,
    x2: 15.4953,
    y2: 9.17526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.601726,
    stopColor: "#F1717D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3599_5722",
    x1: 8.84739,
    y1: 11.5369,
    x2: 7.43543,
    y2: 18.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA3F78",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A0B4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3599_5722",
    x1: 15.5375,
    y1: 8.89178,
    x2: 23.6274,
    y2: 29.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF853B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3599_5722",
    x1: 22.7233,
    y1: 34.0073,
    x2: 0.937984,
    y2: 13.7232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF853B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3599_5722",
    x1: 12.8733,
    y1: 10.802,
    x2: 17.1857,
    y2: 35.5897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3599_5722",
    x1: 24.126,
    y1: 22.9507,
    x2: 18.5697,
    y2: 29.8864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCC02",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6D02"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5d1cd6c0f35707714ae97067be061839.svg";
export { ForwardRef as ReactComponent };